import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
const NonTeachingStaffCard = () => {
  const [count, setCount] = useState(null);

  useEffect(() => {
    const sessionId = localStorage.getItem("currentSessionId");

    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/students/students/count-summary`, {
        params: { sessionId }
      })
      .then(res => setCount(res.data.nonTeachingStaff))
      .catch(err => console.error("Non-teaching staff error:", err));
  }, []);

  return (
    <Link to="/staff-report?type=nonTeaching" className="flex">
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-5 flex items-center justify-between min-h-[110px] hover:shadow-md transition">
      
      <div>
        <p className="text-sm text-gray-500 font-medium">Non-Teaching Staff</p>
        <h3 className="text-3xl font-bold text-amber-600 mt-1">
          {count === null ? "..." : count}
        </h3>
      </div>

      <div className="w-12 h-12 rounded-full bg-amber-100 text-amber-600 flex items-center justify-center text-xl">
        <i className="fas fa-user-tie"></i>
      </div>

    </div>
    </Link>
  );
};

export default NonTeachingStaffCard;
